import { render, staticRenderFns } from "./item-edit.vue?vue&type=template&id=446b5259"
import script from "./item-edit.vue?vue&type=script&lang=js"
export * from "./item-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports